import { RouteName, PageOrientation } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { PageSize, SinglePaymentParameters } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const usePrintSettings = ({ paymentId }: Pick<SinglePaymentParameters, 'paymentId'>) => {
    const resolveRoute = useResolveRoute();
    const enterpriseId = useCurrentEnterpriseId();

    return {
        url: resolveRoute(RouteName.PaymentDetail, { id: paymentId, query: { enterpriseId, ForPrint: 'True' } }),
        pageSize: PageSize.A4,
        pageOrientation: PageOrientation.Portrait,
    };
};
